module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "ad_card_1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ach"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS BY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MANDA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COTT")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("KNIGHT’S TREASURE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("LADY’S CHOICE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("PRINCE OF DANGER")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("LORD OF THE ISLES")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("HIGHLAND PRINCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE SECRET CLAN: REIVER’S BRIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE SECRET CLAN: HIGHLAND BRIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE SECRET CLAN: HIDDEN HEIRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE SECRET CLAN: ABDUCTED HEIRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("BORDER FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("BORDER STORM")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("BORDER BRIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("HIGHLAND FLING")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("HIGHLAND SECRETS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("HIGHLAND TREASURE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("HIGHLAND SPIRITS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE BAWDY BRIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("DANGEROUS ILLUSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("DANGEROUS ANGELS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("DANGEROUS GAMES")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("DANGEROUS LADY")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("THE ROSE AT TWILIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dc57e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofStorms_ad_card_1.vue
// module id = 69
// module chunks = 0